import { LucideIcon } from 'lucide-react';

interface RestaurantEmptyStateProps {
  icon: LucideIcon;
  title: string;
  description: string;
  hint?: string;
}

const RestaurantEmptyState = ({
  icon: Icon,
  title,
  description,
  hint,
}: RestaurantEmptyStateProps) => {
  return (
    <div className="flex min-h-[340px] items-center justify-center p-8">
      <div className="w-full max-w-lg text-center">
        <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-2xl border border-primary/15 bg-primary/10">
          <Icon className="h-10 w-10 text-primary" />
        </div>

        <h3 className="mt-6 text-title-xsm font-semibold text-black dark:text-white">
          {title}
        </h3>

        <p className="mx-auto mt-3 max-w-md text-sm leading-6 text-bodydark2 dark:text-bodydark">
          {description}
        </p>

        {hint && (
          <div className="mt-8 inline-flex rounded-full border border-primary/20 bg-primary/5 px-4 py-2">
            <span className="text-xs font-medium text-primary">
              {hint}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default RestaurantEmptyState;